import { get } from '@/request/racmBlockRequest';

let basePath = '/dd/port/supplier';

export function login(params) {
  return get(basePath + '/login', params);
}

export function list(params) {
  return get(basePath + '/list', params);
}

export function detail(id) {
  return get(basePath + '/detail/' + id, null);
}

export function fileList(params) {
  return get(basePath + '/file/list', params);
}

export function searchList(params) {
  return get(basePath + '/search/list', params);
}
